import React from 'react';

const CautionIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.99898 5.99999V8.66665M7.99898 11.3333H8.00564M14.4856 12L9.15231 2.66665C9.03602 2.46146 8.86738 2.29078 8.66359 2.17203C8.45981 2.05329 8.22817 1.99072 7.99231 1.99072C7.75645 1.99072 7.52481 2.05329 7.32103 2.17203C7.11724 2.29078 6.9486 2.46146 6.83231 2.66665L1.49898 12C1.38143 12.2036 1.3198 12.4346 1.32032 12.6697C1.32084 12.9047 1.3835 13.1355 1.50194 13.3385C1.62039 13.5416 1.79041 13.7097 1.99477 13.8259C2.19914 13.942 2.43058 14.0021 2.66564 14H13.3323C13.5662 13.9997 13.796 13.938 13.9985 13.8208C14.201 13.7037 14.3691 13.5354 14.486 13.3327C14.6028 13.1301 14.6643 12.9002 14.6643 12.6663C14.6642 12.4324 14.6026 12.2026 14.4856 12Z'
        stroke='currentColor'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CautionIcon;
